import { Button, Input, Modal } from 'antd'
import React, { useEffect, useState } from 'react'
import * as Yup from 'yup'
import { useFormik } from 'formik'
import { getUserId } from '../../../helpers/auth'
import CustomersDropdown from '../../CustomersDropdown'
import { toast } from 'react-toastify'
import CampaignDropdown from '../../CampaignDropdown'
import Loader from '../../../pages/pages/loader'
import { useCreateLoaMutation } from '../../../redux/apis/campaignsManagement/loa/cMLoaApiSlice'

const AddCustomerCampaignModal = () => {
  const [open, setOpen] = useState(false)
  const [create, { isLoading, error, isSuccess }] = useCreateLoaMutation()

  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      campaign: null,
      customer_id: null,
      campaign_loa_dropbox_url: '',
      last_updated_by_id: getUserId()
    },

    validationSchema: Yup.object({
      campaign: Yup.mixed().required('Please Select Campaign Name'),
      customer_id: Yup.number().required('Please Select Customer Name'),
      campaign_loa_dropbox_url: Yup.string().required(
        'Please Enter Campaign Loa Url'
      )
    }),

    onSubmit: async values => {
      try {
        const { customer_id, ...rest } = values
        const payload = {
          ...rest,
          customer: customer_id,
          campaign: Array.isArray(values.campaign) && values.campaign.includes('*')
            ? '*'
            : values.campaign
        }
        await create(payload)
      } catch (error) {
        console.error(error)
      }
    }
  })

  useEffect(() => {
    if (error?.data) {
      const errorMessages = Object.values(error.data).flat()
      errorMessages.forEach(message => {
        toast.error(message)
      })
    }
  }, [error])

  useEffect(() => {
    if (isSuccess) {
      toast.success('Campaign Service Added!')
      setOpen(false)
      validation.resetForm()
    }
  }, [isSuccess])
  return (
    <>
      <Loader isLoading={isLoading} />
      <div className='flex w-full justify-end'>
        <button
          className='btn btn-outline-theme mb-4'
          onClick={() => {
            setOpen(true)
          }}
        >
          Create Customer Campaign LOA
        </button>
      </div>
      <Modal
        open={open}
        title='Create Customer Campaign LOA'
        onCancel={() => setOpen(false)}
        footer={[
          <Button key='back' onClick={() => setOpen(false)}>
            Cancel
          </Button>,
          <Button
            key='submit'
            type='primary'
            onClick={() => {
              if (Object.keys(validation.errors).length !== 0) {
                Object.keys(validation.errors).map(key => {
                  // toast.error(validation.errors[key]);
                })
                return
              }
              validation.handleSubmit()
            }}
          >
            Submit
          </Button>
        ]}
      >
        <div className='gap-8 '>
          <CustomersDropdown
            onBlur={validation.handleBlur}
            onChange={e => {
              validation.setFieldValue('customer_id', e)
              validation.setFieldValue('customer', e)
              validation.setFieldValue('campaign', null)
            }}
            value={validation.values?.customer_id}
          />
          {validation.touched.customer_id && validation.errors.customer_id ? (
            <p className='text-danger'>{validation.errors.customer_id}</p>
          ) : null}
          {validation.values.customer_id ? (
            <>
              <CampaignDropdown
                onBlur={validation.handleBlur}
                onChange={selected => {
                  // If "All" was just added alongside others, keep only "All"
                  // If specific campaigns added while "All" was selected, remove "All"
                  if (Array.isArray(selected)) {
                    const lastPicked = selected[selected.length - 1]
                    if (lastPicked === '*') {
                      validation.setFieldValue('campaign', ['*'])
                    } else {
                      validation.setFieldValue('campaign', selected.filter(v => v !== '*'))
                    }
                  } else {
                    validation.setFieldValue('campaign', selected)
                  }
                }}
                isAll={true}
                mode='multiple'
                value={validation.values?.campaign}
                customer_id={validation.values?.customer_id}
              />
              {validation.touched.campaign &&
              validation.errors.campaign ? (
                <p className='text-danger'>{validation.errors.campaign}</p>
              ) : null}
            </>
          ) : null}
          <div className=' mb-3 flex-1'>
            <label className="form-label">LOA Link</label>
            <Input
              type='text'
              name='campaign_loa_dropbox_url'
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              value={validation.values.campaign_loa_dropbox_url}
            />
            {validation.touched.campaign_loa_dropbox_url &&
            validation.errors.campaign_loa_dropbox_url ? (
              <p className='text-danger'>
                {validation.errors.campaign_loa_dropbox_url}
              </p>
            ) : null}
          </div>
        </div>
      </Modal>
    </>
  )
}

export default AddCustomerCampaignModal
